import { render, staticRenderFns } from "./TeachActivity.vue?vue&type=template&id=acdc33da&scoped=true"
import script from "./TeachActivity.vue?vue&type=script&lang=js"
export * from "./TeachActivity.vue?vue&type=script&lang=js"
import style0 from "./TeachActivity.vue?vue&type=style&index=0&id=acdc33da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdc33da",
  null
  
)

export default component.exports